import styled from 'styled-components'

import { Image } from '@/components'

export const PartnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-self: center;
  gap: 80px;

  .logos {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 48px;
  }

  .row {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    gap: 120px;
  }

  @media (max-width: 1350px) {
    .row {
      gap: 80px;
    }
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  @media (max-width: 900px) {
    .row {
      gap: 40px;
      flex-wrap: wrap-reverse;
    }
  }

  @media (max-width: 500px) {
    gap: 56px;
    width: 100%;
  }
`

type ImageLogoProps = {
  height: number
  width: number
}

export const ImageLogos = styled(Image)<ImageLogoProps>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  @media (max-width: 500px) {
    width: ${(props) => `calc(${props.width}px * 0.7)`};
    height: ${(props) => `calc(${props.height}px * 0.7)`};
  }
`
